import React from "react";
import {IconAngleRight} from "../icons";
import $ from "jquery";

export default function TypePromo(props) {

    let {value, onChange, orderId, update} = props;

    let applyPromo = () => {
        $.post('/order-api/set-promo', {
            code: value,
            order_id: orderId,
        }, (data) => {
            if (data.success) {
                window.toastr.success('Промокод применён');
                update();
            } else {
                window.toastr.error('Промокод не найден');
            }
        });
    };

    return <div>
        <div className="tip">Введите промокод для получения скидки</div>

        <div className="button-input form-group">
            <input
                value={value}
                placeholder="Введите промокод"
                onChange={e => onChange(e.target.value)}
            />
            <button style={{cursor: 'pointer', background: '#35b135'}} className="btn"
                    onClick={applyPromo}>
                <IconAngleRight/>
            </button>
        </div>
    </div>
}